var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "catalog-layout" },
    [
      _c("catalog-filters", {
        attrs: { filters: _vm.filters },
        on: { submited: _vm.onSubmit, reset: _vm.onReset }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "catalog-layout__content" },
        [
          _c(
            "div",
            { staticClass: "catalog-layout__content_head" },
            [
              _c(
                "div",
                { staticClass: "page-switcher" },
                [
                  _c(
                    "router-link",
                    { staticClass: "active", attrs: { to: "/grid" } },
                    [_vm._v("Списком")]
                  ),
                  _vm._v(" "),
                  _c("router-link", { attrs: { to: "/map" } }, [
                    _vm._v("На карте")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "bg" })
                ],
                1
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade", duration: "350" } }, [
                (_vm.sums.apartmentsCount > 0) & (_vm.sums.buildingsCount > 0)
                  ? _c("div", { staticClass: "numbers" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("threeDigits")(_vm.sums.apartmentsCount)
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("small", [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm._f("apartmentsCount")(
                                  _vm.sums.apartmentsCount,
                                  true
                                )
                              ) +
                              "\n                            в продаже\n                        "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("span", [_vm._v(_vm._s(_vm.sums.buildingsCount))]),
                        _vm._v(" "),
                        _c("small", [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm._f("buildingsCount")(
                                  _vm.sums.buildingsCount,
                                  true
                                )
                              ) +
                              "\n                        "
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "keep-alive",
            [
              _c("router-view", {
                attrs: {
                  parent: _vm.parent,
                  buildings: _vm.buildings,
                  "placemarks-data": _vm.placemarks,
                  filters: _vm.filters
                },
                on: {
                  "maps-opened": _vm.onMapsOpened,
                  "grid-opened": _vm.onGridOpened
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", duration: "350" } }, [
        _vm.buildings.isLoading | _vm.placemarks.isLoading
          ? _c("div", { staticClass: "page-spinner show" }, [
              _c("span", {
                staticStyle: {
                  "background-image": "url(/images/logo-blue.svg)"
                }
              })
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }